export default {
  name: 'mortgages',

  endpoints: [
    {
      method: 'GET',
      endpoint: '/info',
      hasParams: false,
      alias: 'info'
    },
    {
      method: 'GET',
      endpoint: '/types',
      hasParams: false,
      alias: 'types'
    },
    {
      method: 'GET',
      endpoint: '/client/:id',
      hasParams: true,
      alias: 'client'
    }
  ]
}
